<template>
  <div class="container">
    <header>
    </header>

    <main class="" style="">

        <div class="row">
            <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
                <div class="card border-0 shadow rounded-3 my-5">
                <div class="card-body p-4 p-sm-5">
                    <h5 class="card-title text-center mb-4 fw-light fs-5">Sretno mladenci!</h5>
                    <!-- <p class="text-center mb-5">Choose provider of your choice and connect Souvie with photo album. On next scan photo album will be opened.
                    </p> -->
                    <p class="mb-5">
                        Katarina i Davor, želim Vam sve najljepše u braku, puno sreće, 
                        ljubavi, avantura i zdravlja! 
                        <br><br>
                        <small>
                            P.S. Pošaljite mi link gdje želite da ovaj QR kod vodi na sljedeće skeniranje - 
                            na zajedničku pjesmu koju volite, s youtubea ili s drive-a, po vašem izboru.
                        </small>
                        <br><br>
                        Lucko
                    </p>
                    <div>

                    </div>
                </div>
                </div>
            </div>
        </div>

    </main>

    <footer class="mt-auto text-white-50">
    </footer>

  </div>
</template>

<script>
/* global bootstrap */
export default {
  name: 'Davor',
  data() {
    return {}
  },
  mounted() {
    // Load Bootstrap dynamically when the component is mounted
    this.loadBootstrap();
    // this.initializeGoogle();
  },
  methods: {
    loadBootstrap() {
      // Check if Bootstrap is already loaded
      if (typeof bootstrap === 'undefined') {
        // If not, load it dynamically
        const script = document.createElement('script');
        script.src = '/bootstrap/js/bootstrap.min.js';

        script.onload = () => {
          // Bootstrap is now loaded, you can use it here
          console.log("Bootstrap loaded")
          this.initializeBootstrap();
        };

        // Append the script to the document
        document.head.appendChild(script);
      } else {
        // If Bootstrap is already loaded, initialize it
        this.initializeBootstrap();
      }
    },
    initializeBootstrap() {
      var toastElList = [].slice.call(document.querySelectorAll('.toast'))
      this.toastElList = toastElList.map(function (toastEl) {
        return new bootstrap.Toast(toastEl)
      })
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* — ♥️ decorations — */
.container{
  position:relative;       /* anchor the pseudo-elements */
  overflow:hidden;         /* keeps hearts from spilling onto the page */
  z-index:0;
}

/* big hearts drifting just outside the card-area */
.container::before,
.container::after{
  content:"❤️ 🩷 💜";
  font-size:3.5rem;
  position:absolute;
  opacity:.35;
  pointer-events:none;
  transform:rotate(-12deg);
}

.container::before{ top:-2.5rem;  left:-1rem;  }
.container::after { bottom:-2.5rem; right:-1rem; transform:rotate(12deg); }

/* smaller hearts hugging the card’s corners */
.card{
  position:relative;       /* anchor the card hearts */
  z-index:1;               /* keep above container hearts */
}

.card::before,
.card::after{
  content:"💖";
  font-size:2.5rem;
  position:absolute;
  opacity:.30;
  pointer-events:none;
}

.card::before{ top:-1rem;    left:-1rem;  }
.card::after { bottom:-1rem; right:-1rem; }
</style>
